{
  "zh-TW": {
    "actions": {
      "hangarShare": {
        "enable": "建立分享連結",
        "rotate": "重設連結",
        "disable": "刪除分享連結"
      },
      "announcements": {
        "addPart": "新增",
        "removePart": "移除",
        "movePartUp": "上移",
        "movePartDown": "下移",
        "sendTest": "發送測試",
        "publish": "發送",
        "retry": "重試",
        "refreshEngagement": "重新整理數據",
        "openPost": "開啟貼文"
      },
      "admin": {
        "dashboard": {
          "reloadModels": "重新載入模型",
          "reloadScData": "重新載入 SC 資料",
          "reloadPaints": "重新載入塗裝",
          "reloadModules": "重新載入模組",
          "reloadLoaners": "重新載入借用船"
        },
        "supporterContributions": {
          "syncFromPatreon": "從 Patreon 同步"
        },
        "imports": {
          "loadAll": "全部載入",
          "load": "載入",
          "loadScData": "載入 SC 資料",
          "loadShipMatrix": "載入艦船矩陣",
          "cleanup": "標記為失敗",
          "cleanupSelected": "將所選標記為失敗"
        }
      },
      "duplicate": "複製",
      "upgrade": "更新可用！",
      "backToHome": "規劃新航線",
      "disableGrouping": "停用分組",
      "enableGrouping": "啟用分組",
      "groupedByModel": "按型號分組",
      "destroyAccount": "刪除帳戶",
      "saveScreenshot": "儲存為PNG",
      "resolve": "解決",
      "sortBy": "排序方式",
      "back": "返回",
      "open": "開啟",
      "copy": "複製",
      "download": "下載",
      "zoom": "縮放",
      "viewImage": "檢視 %{name} 原圖",
      "more": "更多...",
      "export": "匯出",
      "exportHangarLink": "匯出至 hangar.link",
      "import": "匯入",
      "here": "這裡",
      "previous": "上一個",
      "next": "下一個",
      "cancel": "取消",
      "ok": "確定",
      "reset": "重置",
      "reload": "重新載入",
      "retry": "重試",
      "confirm": "確認",
      "showDetailPage": "詳情頁面",
      "showDetails": "顯示詳情",
      "hideDetails": "隱藏詳情",
      "showPledgeValue": "顯示認購價值",
      "showInGameBoughtValue": "顯示遊戲內購買價值",
      "readMore": "閱讀更多",
      "readLess": "收起",
      "showGuide": "顯示導覽",
      "tour": {
        "next": "下一步",
        "back": "上一步",
        "skip": "略過導覽",
        "done": "完成"
      },
      "showFleetchart": "艦隊圖表",
      "hideFleetchart": "預設檢視",
      "fleetchartApp": {
        "useExtendedState": "顯示展開狀態的飛船",
        "useRetractedState": "顯示飛行狀態的飛船"
      },
      "showLabels": "顯示標籤",
      "hideLabels": "隱藏標籤",
      "resetZoom": "重置縮放",
      "supportUs": "支援FleetYards.net",
      "appUpdate": {
        "reload": "重新載入",
        "whatsNew": "新功能"
      },
      "installApp": {
        "cta": "安裝應用程式",
        "later": "稍後再說"
      },
      "supportHint": {
        "cta": "支援 FleetYards",
        "later": "稍後再說"
      },
      "login": "登入",
      "signUp": "註冊",
      "confirmAccess": "確認密碼",
      "sendConfirmAccessEmail": "傳送確認郵件",
      "reset-password": "忘記密碼？",
      "edit": "編輯",
      "clear": "清除",
      "done": "完成",
      "share": "分享",
      "change": "更改",
      "upload": "上傳",
      "save": "儲存",
      "enable": "啟用",
      "disable": "停用",
      "manage": "管理",
      "enableGlobally": "全域啟用",
      "disableGlobally": "全域停用",
      "addActor": "新增角色",
      "addGroup": "新增群組",
      "editGroup": "編輯群組",
      "remove": "移除",
      "reorder": "重新排序",
      "moveUp": "上移",
      "moveDown": "下移",
      "delete": "刪除",
      "deleteSelected": "刪除選中項",
      "enableSelected": "啟用選中項",
      "disableSelected": "停用選中項",
      "presets": {
        "choose": "選擇圖片",
        "remove": "移除圖片"
      },
      "close": "關閉",
      "filter": "篩選",
      "showStatusColor": "顯示狀態顏色",
      "hideStatusColor": "隱藏狀態顏色",
      "addToHangar": "新增至機庫",
      "blueprint": {
        "apply": "套用",
        "discard": "放棄",
        "removeCrafting": "移除製作",
        "own": "標記為已擁有",
        "unown": "取消已擁有標記"
      },
      "resetFilter": "重置篩選器",
      "requestPassword": "請求密碼郵件",
      "changePassword": "更改密碼",
      "updatePassword": "更新密碼",
      "copyBackupCodes": "複製備份代碼",
      "regenerate": "重新產生",
      "add": "新增",
      "create": "建立",
      "addToWishlist": "新增至願望清單",
      "addVehicle": "新增飛船",
      "showTableView": "清單",
      "showGridView": "網格",
      "linkExisting": "連結現有",
      "loadMore": "載入更多",
      "unlink": "取消連結",
      "syncRsiBuybacks": "同步 RSI 回購",
      "syncRsiHangar": "同步RSI機庫",
      "oauthApplications": {
        "create": "新增應用程式",
        "regenerateSecret": "重新產生密鑰",
        "approve": "核准",
        "reject": "拒絕",
        "rejectSelected": "拒絕所選"
      },
      "oauthAuthorize": {
        "authorize": "授權",
        "deny": "拒絕"
      },
      "verifyWithCitizenId": "使用 Citizen iD 驗證",
      "user": {
        "rsiVerification": {
          "verify": "透過 RSI 個人資料驗證",
          "check": "立即檢查",
          "checkIn": "%{seconds} 秒後可再次檢查",
          "copyToken": "複製驗證碼",
          "regenerateToken": "產生新的驗證碼",
          "revoke": "撤銷"
        }
      },
      "oauth": {
        "signInWith": "透過以下方式登入",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "已連接到 Google",
          "discord": "已連接到 Discord",
          "bluesky": "已連接到 BlueSky",
          "github": "已連接到 GitHub",
          "twitch": "已連接到 Twitch",
          "citizenid": "已連接到 Citizen iD",
          "patreon": "已連結 Patreon"
        },
        "disconnect": {
          "google": "中斷 Google 連線",
          "discord": "中斷 Discord 連線",
          "bluesky": "中斷 BlueSky 連線",
          "github": "中斷 GitHub 連線",
          "twitch": "中斷 Twitch 連線",
          "citizenid": "中斷 Citizen iD 連線",
          "patreon": "中斷 Patreon"
        },
        "patreon": "Patreon"
      },
      "compare": {
        "ships": "對比"
      },
      "cargoGrids": {
        "addShips": "新增飛船"
      },
      "tradeRoutes": {
        "pickShip": "選擇飛船",
        "changeShip": "更換飛船",
        "editRun": "編輯",
        "doneEditing": "完成",
        "backToRuns": "返回所有航程",
        "showMore": "顯示更多航程"
      },
      "hangar": {
        "editGroups": "Add or remove Groups",
        "editName": "Name your Ship",
        "manageLoadouts": "管理配置",
        "manageCargo": "管理貨物",
        "useName": "Use Name",
        "destroyAll": "Remove all Ships",
        "showOnPublicHangar": "Make Public",
        "hideFromPublicHangar": "Hide from Public",
        "editGroupsSelected": "Add/Remove from Groups",
        "hideFromHangar": "從機庫中隱藏",
        "showInHangar": "在機庫中顯示",
        "resetIngame": {
          "openModal": "資料重置後重設遊戲內飛船",
          "moveToWishlist": "移至願望清單",
          "removeAll": "全部移除"
        },
        "editLoadout": "編輯裝配"
      },
      "syncExtension": {
        "cancel": "取消",
        "start": "Start Sync",
        "retry": "重試同步",
        "runInBackground": "在背景繼續",
        "showResult": "查看結果",
        "close": "關閉",
        "refresh": "重新整理頁面",
        "checkAgain": "再次檢查",
        "addExtension": "新增",
        "updateExtension": "更新",
        "change": "變更"
      },
      "empty": {
        "hangarGuide": "開始導覽",
        "reset": "清除篩選"
      },
      "destroyFleet": "解散艦隊",
      "restore": "還原",
      "fleet": {
        "fidClaim": {
          "claim": "申領 %{fid}",
          "withdraw": "撤回申領",
          "useSuggestion": "使用 %{suggestion}",
          "endNow": "立即結束寬限期",
          "cancel": "取消申領"
        },
        "rsiVerification": {
          "verify": "驗證",
          "regenerateToken": "產生新的驗證碼",
          "check": "立即檢查",
          "copyToken": "複製驗證碼",
          "revoke": "撤銷"
        },
        "join": "Join %{fleet}!",
        "leave": "Leave %{fleet}",
        "createInviteUrl": "Create Invite Urls",
        "inviteMember": "Invite new Member",
        "squadrons": {
          "create": "建立中隊",
          "addMember": "新增成員",
          "removeMember": "移出中隊",
          "addMembers": "新增 %{count} 位",
          "viewMembers": "中隊成員",
          "viewShips": "中隊艦船",
          "viewStats": "中隊統計",
          "join": "加入團隊",
          "leave": "退出",
          "requestJoin": "申請加入",
          "withdrawRequest": "撤回申請",
          "acceptRequest": "接受",
          "declineRequest": "拒絕",
          "promote": "晉升",
          "demote": "降級"
        },
        "manageInvites": "邀請",
        "worldmap": "世界地圖",
        "starmap": "星圖",
        "acceptInvite": "Accept Invitation",
        "declineInvite": "Decline Invitation",
        "acceptRequest": "accept Request",
        "declineRequest": "Decline Request",
        "members": {
          "invite": "Invite",
          "promote": "Promote",
          "demote": "Demote",
          "accept": "Accept",
          "decline": "Decline",
          "remove": "移除",
          "editRole": "編輯角色",
          "editNickname": "編輯暱稱",
          "health": {
            "open": "成員健康檢查",
            "showAll": "顯示全部 %{count} 個",
            "inviteLinks": "邀請連結",
            "discordSettings": "Discord 設定",
            "verifyOrg": "驗證 RSI 組織",
            "remove": "移出艦隊",
            "revoke": "撤回邀請",
            "deleteLink": "刪除連結",
            "promoteTo": "晉升為 %{role}",
            "addToSquadron": "加入中隊",
            "addToNamedSquadron": "加入%{squadron}",
            "addMembers": "新增成員",
            "deleteSquadron": "解散",
            "remind": "提醒驗證"
          }
        },
        "inviteUrls": {
          "create": "Create new Invite Url"
        },
        "discord": {
          "test": "測試 Discord 連線",
          "installBot": "在你的 Discord 伺服器安裝 Fleetyards 機器人"
        },
        "calendarSubscription": {
          "enable": "產生訂閱連結",
          "rotate": "更換連結",
          "disable": "停用訂閱"
        }
      },
      "model": {
        "gallery": "Gallery",
        "onSale": "On Sale: %{price}",
        "store": "RSI Page"
      },
      "models": {
        "sync": "從 RSI 同步",
        "syncMatrix": "同步矩陣",
        "syncScData": "同步 SC 資料",
        "importPaints": "匯入塗裝",
        "syncShipViews": "同步艦船視圖",
        "exchangeStoreImage": "使用 RSI 圖片",
        "images": "圖片",
        "openTableConfiguration": "開啟表格設定"
      },
      "users": {
        "loginAs": "以使用者身分登入",
        "resendConfirmation": "重新傳送確認",
        "sendPasswordReset": "傳送密碼重設"
      },
      "unselect": "Unselect all Selected",
      "twoFactor": {
        "enable": "Enable Two-factor",
        "disable": "Disable Two-factor",
        "generateBackupCodes": "產生備用碼"
      },
      "holoViewer": {
        "loadAnyway": "仍要載入",
        "autoRotate": {
          "enable": "Enable auto rotate",
          "disable": "Disable auto rotate"
        },
        "zoom": {
          "enable": "Enable zoom",
          "disable": "Disable zoom"
        },
        "color": {
          "enable": "Enable colors",
          "disable": "Disable colors"
        }
      },
      "logistics": {
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "清空貨物",
        "viewCargoGrid": "檢視貨艙網格",
        "sendTransfer": "傳送",
        "moveStock": "移動",
        "transfer": "轉移",
        "acceptTransfer": "接受",
        "declineTransfer": "拒絕",
        "cancelTransfer": "撤回",
        "reportTransfer": "檢舉",
        "resetToMax": "重設為最大值",
        "removeLine": "移除"
      },
      "adminNotifications": {
        "read": "標示為已讀",
        "unread": "標示為未讀",
        "archive": "封存",
        "unarchive": "移回收件匣",
        "readAll": "全部標示為已讀",
        "destroyAll": "全部刪除",
        "sortOldest": "最舊的優先",
        "sortNewest": "最新的優先",
        "select": "選取通知",
        "readSelected": "將選取項目標示為已讀",
        "unreadSelected": "將選取項目標示為未讀",
        "archiveSelected": "封存選取項目",
        "unarchiveSelected": "將選取項目移回收件匣",
        "destroySelected": "刪除選取項目"
      },
      "account": {
        "calendarSubscription": {
          "enable": "產生個人行事曆連結",
          "rotate": "更換連結",
          "disable": "停用訂閱"
        }
      },
      "today": "今天",
      "fleets": {
        "missions": {
          "publish": "發布",
          "create": "建立任務",
          "edit": "編輯任務",
          "archive": "封存任務",
          "unarchive": "取消封存",
          "destroy": "永久刪除",
          "addTeam": "新增隊伍",
          "addShip": "新增飛船",
          "addSlot": "新增席位",
          "viewMissions": "檢視任務"
        },
        "tours": {
          "viewTours": "查看行程"
        },
        "events": {
          "create": "建立活動",
          "edit": "編輯活動",
          "spawn": "從此任務建立活動",
          "archive": "封存活動",
          "unarchive": "從封存還原",
          "syncToDiscord": "同步至 Discord",
          "destroy": "永久刪除",
          "publish": "發布",
          "lockSignups": "鎖定報名",
          "unlockSignups": "解除報名鎖定",
          "start": "開始",
          "complete": "完成",
          "cancel": "取消",
          "signup": "報名",
          "withdraw": "取消報名",
          "kick": "移除報名",
          "addToCalendar": "加入行事曆",
          "subscribe": "訂閱",
          "setUpCalendar": "設定行事曆訂閱",
          "assignSlot": "指派席位",
          "reassignSlot": "移至其他席位",
          "manageEventTeam": "管理活動團隊",
          "grantRole": "授予角色",
          "revokeRole": "撤銷",
          "addTeam": "新增隊伍"
        },
        "contracts": {
          "create": "建立合約",
          "save": "儲存合約",
          "publish": "發布",
          "claim": "接下",
          "join": "申請加入",
          "release": "放棄",
          "fulfil": "標記為完成",
          "cancel": "取消合約",
          "edit": "編輯",
          "leave": "退出",
          "remove": "移除",
          "acceptCrew": "同意",
          "declineCrew": "拒絕",
          "addItem": "新增貨物",
          "payouts": "分帳"
        }
      },
      "notifications": {
        "read": "標示為已讀",
        "unread": "標示為未讀",
        "archive": "封存",
        "unarchive": "移回收件匣",
        "readAll": "全部標示為已讀",
        "destroyAll": "全部刪除",
        "settings": "通知設定",
        "sortOldest": "最舊的優先",
        "sortNewest": "最新的優先",
        "openCenter": "通知",
        "pushEnable": "在此裝置上開啟",
        "pushDisable": "在此裝置上關閉",
        "pushRemove": "移除",
        "select": "選取通知",
        "readSelected": "將選取項目標示為已讀",
        "unreadSelected": "將選取項目標示為未讀",
        "archiveSelected": "封存選取項目",
        "unarchiveSelected": "將選取項目移回收件匣",
        "destroySelected": "刪除選取項目"
      },
      "unlistedModel": {
        "createModel": "建立飛船",
        "markAsPaint": "這是塗裝",
        "ignore": "忽略",
        "noManufacturer": "此識別碼無法解析出製造商",
        "alreadyExists": "%{name} 已在目錄中",
        "link": "已在目錄中",
        "markAsPaintSelected": "將所選標記為塗裝",
        "ignoreSelected": "忽略所選"
      },
      "revert": "還原",
      "exportCsv": "匯出 CSV",
      "exportAllCsv": "全部匯出為 CSV",
      "imports": {
        "cancel": "取消",
        "downloadExample": "範例檔案",
        "toggleDetails": "查看詳情"
      },
      "selectFile": "選擇檔案",
      "applyGameFileValue": "採用",
      "applyAllGameFileValues": "全部採用",
      "payouts": {
        "archiveTour": "封存",
        "unarchiveTour": "還原",
        "deleteTour": "刪除",
        "openLedger": "開啟分帳簿",
        "addEntry": "記一筆",
        "addParticipant": "新增參與者",
        "settle": "結算並計算分帳",
        "reopen": "重新開啟",
        "confirm": "標記為已付",
        "unconfirm": "標記為未付",
        "createTour": "建立行程",
        "joinTour": "加入行程",
        "rotateInvite": "產生新連結",
        "askToJoin": "申請參加",
        "withdrawJoinRequest": "撤回申請",
        "approveJoinRequest": "通過",
        "declineJoinRequest": "拒絕",
        "approveExpense": "核准",
        "declineExpense": "拒絕"
      },
      "relationships": {
        "accept": "接受",
        "decline": "拒絕",
        "ignore": "忽略",
        "withdraw": "撤回",
        "end": "移除",
        "send": "發送請求",
        "user": {
          "add": "新增好友"
        },
        "fleet": {
          "add": "新增盟友"
        }
      },
      "supporterNomination": {
        "change": "變更艦隊"
      },
      "vehiclePlaque": {
        "remove": "移除銘牌",
        "edit": "編輯銘牌",
        "show": "查看命名銘牌"
      },
      "vehicleOverview": {
        "open": "概覽",
        "uploadPicture": "上傳圖片",
        "changePicture": "更換圖片",
        "edit": "編輯艦船",
        "shipDatabase": "艦船資料庫",
        "openLog": "開啟日誌",
        "applyPaint": "套用 %{paint}",
        "editPaints": "編輯塗裝",
        "editLocation": "變更位置",
        "allPaints": "全部 %{count} 款塗裝",
        "fullscreenHolo": "全螢幕",
        "allUpgrades": "全部 %{count} 個升級",
        "allBuybacks": "全部 %{count} 個可回購承諾"
      },
      "vehicleLog": {
        "open": "艦長日誌",
        "add": "新條目",
        "showPublic": "艦長日誌"
      },
      "vehicleLoadout": {
        "craft": "製作",
        "swapModule": "更換模組",
        "removeModule": "移除模組",
        "editLoadout": "編輯配置",
        "newLoadout": "新增配置",
        "saveLoadout": "儲存配置",
        "saveAsNewLoadout": "另存為新配置",
        "openLoadoutPage": "開啟配置頁面",
        "makePublic": "設為公開",
        "makePrivate": "設為私密",
        "linkInstead": "改為連結配置",
        "createOnFleetyards": "在 Fleetyards 上建立配置",
        "viewLoadout": "查看配置"
      },
      "hangarPledgeItems": {
        "addToInventory": "加入庫存",
        "addCount": {
          "other": "加入 %{count} 項"
        },
        "createInventory": "建立庫存"
      }
    }
  }
}
